import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import SkinKey from "../../../../../shared/src/ranj/app/ui/SkinKey";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import SplashLoadScreenMediator from "../view/SplashLoadScreenMediator";
import GateKeeperOverlayMediator from '../view/GateKeeperOverlayMediator.js';
import TutorialOverlayMediator from '../view/TutorialOverlayMediator.js';
import GameScreenMediator from '../view/GameScreenMediator.js';
import EndScreenMediator from "../view/EndScreenMediator";

export default class ConfigureDirectionalSkinsTask extends Task {

    /**
     * Configures asset library and skin mappings for LTR or RTL based on language direction
     * This task must run after InitLanguageTask so appModel.rtl is available
     * 
     * @param {AppModel} appModel 
     * @param {soma.Injector} injector 
     * @param {MediatorMap} mediatorMap
     */
    constructor(appModel, injector, mediatorMap) {
        super();

        /**
         * Helper function to map a skin to a mediator, mirroring _mapMediator pattern
         * @param {*} mediatorClass - The mediator class to map to
         * @param {*} skinClass - The skin class to map
         * @returns {SkinKey} The created skin key
         */
        const mapSkin = (mediatorClass, skinClass) => {
            const key = new SkinKey(skinClass);
            if (mediatorClass != null) {
                mediatorMap.map(key, mediatorClass);
            }
            return key;
        };

        this.execute = function (callback, progressCallback) {

            const isRTL = appModel.rtl;
            
            // Add the correct directional asset variants for main game and dialog assets
            const startupAssetGroups = injector.getValue("startupAssetGroups");
            
            if (isRTL) {
                startupAssetGroups.push("MainAssets_RTL", "LevelAssets_RTL");
            } else {
                startupAssetGroups.push("MainAssets", "LevelAssets");
            }
                       
            // Select & inject the correct lib objects based on language direction
            const SplashAssetsLib = isRTL ? lib.SplashAssets_RTL : lib.SplashAssets;
            const MainAssetsLib = isRTL ? lib.MainAssets_RTL : lib.MainAssets;
            const LevelAssetsLib = isRTL ? lib.LevelAssets_RTL : lib.LevelAssets;

            injector.mapValue("splashAssets", SplashAssetsLib);
            injector.mapValue("gameAssets", MainAssetsLib);
            injector.mapValue("levelAssets", LevelAssetsLib);
            
            // Map (directional variants of) screen skins
            SkinKeys.SPLASH_LOAD_SCREEN_SKIN = mapSkin(SplashLoadScreenMediator, SplashAssetsLib.SplashLoadScreenSkin);
            SkinKeys.GAME_SCREEN = mapSkin(GameScreenMediator, MainAssetsLib.GameScreenSkin);
            SkinKeys.END_SCREEN = mapSkin(EndScreenMediator, MainAssetsLib.EndScreenSkin);
            SkinKeys.TUTORIAL_OVERLAY = mapSkin(TutorialOverlayMediator, MainAssetsLib.TutorialOverlaySkin);
            SkinKeys.GATEKEEPER_OVERLAY = mapSkin(GateKeeperOverlayMediator, MainAssetsLib.GateKeeperOverlaySkin);

            callback(this);
        }
    }

}